module.exports = __webpack_public_path__ + "img/p5.84b7d316.png";